jQuery(document).ready(function($) { 

	var l_window = parseInt($(window).width());
	var header = $('#masthead');

   	 /*  ***************************
       SCROLL FIXED MENU 
     ******************************** */

      $(window).scroll(function () {
        // if(l_window > 1023){
           action_on_scroll();
        // }
       });

    function action_on_scroll(){
       if ($(window).scrollTop() > 50){
          header.addClass("Masthead--sticky");
          $("body").addClass('header--sticky');
        }else{
           header.removeClass("Masthead--sticky");
           $("body").removeClass('header--sticky');
        }
   }

   /**************************************************************/
   /************ ANIMATION QUI SOMMES-NOUS **********************/
   /**************************************************************/

   // var cache_qsn = document.querySelector(".qui-sommes-nous .qsn-inner-cache");
   // var qsn_trigger = document.querySelector(".qui-sommes-nous .qsn-inner");
   //     gsap.from(cache_qsn,1,{
   //        width:'100%',
   //        ease: "power0.out",
   //        scrollTrigger: {
   //          trigger:qsn_trigger,
   //           //start: "top bottom", // the default values
   //           end: "center center",
   //           scrub: true,
   //           //invalidateOnRefresh: true,
   //          //immediateRender:false,
   //          toggleActions: "restart pause resume restart",
   //        }, 
   //      });



  // FORM CONTACT LABEL ///

  $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

  $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });





  
   $('.hTeamM-Desc').hide(); //   $('.accordion-section-content:not(.first)').hide();


    $('.hTeamM-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('aria-controls');
        
        var parentActiveAcc = $(this).parent().parent().parent().attr('data-accordion-id');


         //$(parentActiveAcc + ' .hTeamM.active .hTeamM-Desc').not('#'+currentAttrValue).slideUp(300);
         //$(parentActiveAcc + ' .hTeamM.active .hTeamM-title:not([aria-controls="'+currentAttrValue+'"])').attr('aria-expanded', 'false');
         //$(parentActiveAcc + ' .hTeamM.active .hTeamM-Desc').not('#'+currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           
            $(this).attr('aria-expanded', 'false');
            $('#'+currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          
            $(this).parent().parent().addClass('active');
            $(this).attr('aria-expanded', 'true');
            // Open up the hidden content panel
            $('#'+currentAttrValue).slideDown(300).addClass('open');
        }
 
        e.preventDefault();
    });
    // FIN accordion //
    ////////////////////



      /**************************************************************/
   /************ ANIMATION ELT DECORATION FIN HOME **********************/
   /**************************************************************/


    ScrollTrigger.create({
      trigger: '.serviceItem-Container',
      end: "bottom center",
      toggleActions: "restart pause resume restart",
       toggleClass: {targets: '.serviceItem-Container', className: "is-active"},
   });



    /************ ANIMATION PAGE SERVICE **********************/
   /**************************************************************/
     
      /**************************************************************/
   /************ ANIMATION CARDS SERVICE **********************/
   /**************************************************************/
       gsap.utils.toArray(".CardsService-Container").forEach(CardsServiceContainer => {
                ScrollTrigger.create({
                  trigger: CardsServiceContainer,
                  end: "bottom center",
                  toggleActions: "restart pause resume restart",
                   toggleClass: {targets: CardsServiceContainer, className: "is-active"},
               });
    });
    
     /**************************************************************/
   /************ ANIMATION CACHE INTRO SERV **********************/
   /**************************************************************/

         gsap.utils.toArray(".Anim-Discover").forEach(BigServiceIntro => {
             ScrollTrigger.create({
              trigger: BigServiceIntro,
              start:"top center",
              // end: "bottom bottom",
              toggleActions: "restart pause resume restart",
               toggleClass: {targets: BigServiceIntro, className: "is-active"},
        });
    });


      /**************************************************************/
   /************ ANIMATION STEP - SERVICE **********************/
   /**************************************************************/
     
     gsap.utils.toArray(".serviceStep").forEach(serviceStep => {
     //var bloc_step = ServiceStep.querySelector(".RowTxtImg-Img");
             ScrollTrigger.create({
              trigger: serviceStep,
            //  start:"top center",
              end: "bottom center",
              toggleActions: "restart pause resume restart",
            toggleClass: {targets: serviceStep, className: "is-active"},
        });
    });

       /**************************************************************/
   /************ ANIMATION IMAGES - SERVICE **********************/
   /**************************************************************/
    
   gsap.utils.toArray(".anim-ImagesServL").forEach(animImagesServL => {
     //var bloc_step = ServiceStep.querySelector(".RowTxtImg-Img");
             ScrollTrigger.create({
              trigger: animImagesServL,
              end: "bottom center",
              toggleActions: "restart pause resume restart",
               toggleClass: {targets: animImagesServL, className: "is-active"},
        });
    });




    // /**************************************************************************************/
        // /*********************** SLIDER DE LOGO DANS A PROPOS  *********************************/
    // /**************************************************************************************/


     var swiper_container_LogoSlider = new Swiper('.swiper-container-LogoSlider', {

      // If we need pagination
        spaceBetween: 20, // try '5%' if you want
        slidesPerView: 3,
        loop: true,
        centeredSlides:false,
         autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        navigation: {
          nextEl: '.swiper-button-nav-logos .swiper-button-next',
          prevEl: '.swiper-button-nav-logos .swiper-button-prev',
        },
        breakpoints: {
          1200: { // a partir de 12001
            slidesPerView: 4,
            centeredSlides:false,
            spaceBetween: 60,
          },
          768: { // a partir de 769
            slidesPerView: 3,
            centeredSlides:false,
            spaceBetween: 40,
          }
        }

    });




     var top_scroll = 80;
      $(document).on("click", ".scroll-page a", function(e) {

         var item_href = $(this).attr("href");
             const href_diese = item_href.split('#');
             if ($('#'+href_diese[1]).length){
                var offsetTop = $('#'+href_diese[1]).offset().top-top_scroll;
                $('html, body').stop().animate({ 
                  scrollTop: offsetTop
              }, 600);

             if($('#masthead').hasClass('open')){
                $( ".menu-toggle" ).trigger( "click" );
            }
              e.preventDefault();
         }
        


      });






}); // fin ready menu